import React, { useEffect, useState } from "react";
import {
  Button,
  Stack,
  IconButton,
  InputAdornment,
  TextField,
  MenuItem,
  Autocomplete,
  Grid,
  Paper,
} from "@mui/material";
import Iconify from "../../../../components/Iconify";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useMutation, useQuery } from "@apollo/client";
import { AGREGAR_SUBCAT_EGRESO, OBTENER_CAT_EGRESOS } from "../../../../graphql/egresos";
const FrmAgregarSubcuentaEgresos = ({
  setOpenDialog,
  setOpenSnackBar,
  setErrorGraph,
}) => {
  const [agregarCategoriaSubEgresos] = useMutation(AGREGAR_SUBCAT_EGRESO);
  const {data, loading, error} = useQuery(OBTENER_CAT_EGRESOS)
  //formik
  const formik = useFormik({
    initialValues: {
      descripcion: "",
      CatEgresosId: "",
    },
    validationSchema: Yup.object({
      descripcion: Yup.string().required("La clave de subcuenta es requerida"),
    }),
    onSubmit: async (inputdata) => {
      console.log(inputdata);
      const result = await agregarCategoriaSubEgresos({
        variables: {
          input: {
            clave: null, 
            descripcion: inputdata.descripcion,
            CatEgresosId: inputdata.CatEgresosId,
          },
        },
      });
      setOpenSnackBar(true);
      setErrorGraph({
        mensaje: result.data.agregarCategoriaSubEgresos,
        severity: "success",
      });
      formik.resetForm();
    },
  });

  const handleOpenDialog = () => {
    setOpenDialog(false);
    //setOpenSnackBar(true);
  };
  if(loading) return <h1>Cargando datos...</h1>
  const { obtenerCategoriasEgresos } = data;
  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Paper style={{ padding: 10 }}>
          <Grid container alignItems="flex-start" spacing={3}>
            <Grid item xs={12}>
              <TextField
                label="Subcuenta"
                fullWidth={true}
                variant="standard"
                id="descripcion"
                value={formik.values.descripcion}
                onChange={formik.handleChange}
              />
              {formik.errors.descripcion}
            </Grid>
            <Grid item xs={12}>
            <TextField
                name="CatEgresosId"
                select
                label="Tipo de Egreso"
                helperText="Seleccione una categoría para este registro"
                variant="standard"
                fullWidth
                value={formik.values.CatEgresosId}
                onChange={formik.handleChange}
              // onChange={e => handleSubcategoria(e.target.value)}
              >
                {obtenerCategoriasEgresos.map((options) => (
                  <MenuItem key={options.clave} value={options.clave}>
                    {options.clave}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
              <Button
                type="submit"
                startIcon={<Iconify icon="eva:save-outline" />}
              >
                Guardar
              </Button>
              <Button
                onClick={() => handleOpenDialog()}
                color="error"
                startIcon={<Iconify icon="eva:close-outline" />}
              >
                Cerrar
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </form>
    </>
  );
};

export default FrmAgregarSubcuentaEgresos;
